import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { Amplify } from 'aws-amplify';
import outputs from '../../amplify_outputs.json';

//Amplify.configure(outputs);


@Component({
  selector: 'app-root',
  standalone: true,
  /*imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'*/
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {
  title = 'AI Chatbot KB';
}
